var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.17088 10.4998L5.40422 10.8998C6.45424 12.6998 8.55424 12.6998 9.60424 10.8998L9.83757 10.4998M2.9442 9.07044L3.00449 9.19474C3.39169 9.99298 4.20091 10.4998 5.0881 10.4998H9.8836C10.6439 10.4998 11.3514 10.1115 11.7596 9.47008C12.3358 8.56469 12.1832 7.37696 11.3968 6.64663L11.3712 6.62289C10.8373 6.12705 10.5744 5.40467 10.6648 4.68166L10.7025 4.38012C10.9158 2.67371 9.58528 1.1665 7.86562 1.1665H6.8722C5.15464 1.1665 3.82572 2.67188 4.03876 4.3762L4.08506 4.74653C4.1703 5.42852 3.92119 6.10973 3.41609 6.57581C2.72617 7.21246 2.53449 8.22577 2.9442 9.07044Z",
    stroke: "#53545C",
    strokeWidth: 0.821918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification_icon.2651502ee5d2c935c83381eb8ba5c6c7.svg";
export { ForwardRef as ReactComponent };